import { useNavigate } from 'react-router-dom'

import { Box, Button, Card } from '@factorialco/deprecated-design-system'
import type { AllProductUpdatesQuery } from 'generated/resources/graphql'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

type ProductUpdatesUpdate =
  AllProductUpdatesQuery['productUpdates']['updatesConnection']['edges'][number]['node']

interface Props {
  onClose: () => void
  productUpdates: ProductUpdatesUpdate[]
  productName: string | undefined
}

export const ProductUpdatesSidepanel = ({ onClose, productUpdates, productName }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  return (
    <Sidepanel
      title={i18n.t('product_updates.omnibutton.title', { product_name: productName })}
      onClose={onClose}
      boxPadding={false}
      closeLabel={i18n.t('common.close')}
      open
      footer={
        <Button
          iconName="external link"
          onClick={() => {
            track(trackingEvents.productUpdates.visitProductUpdatesPage, {
              origin: 'omnibutton',
            })
            navigate(navigation.discover.productUpdates.fullPath())
            onClose()
          }}
        >
          {i18n.t('product_updates.omnibutton.cta')}
        </Button>
      }
    >
      {productUpdates.map((update, index) => (
        <Box key={index} padding="s24" gap="s24">
          <Card key={update.id} img={update.thumbnail.src}>
            <Card.Content>
              <Box gap="s8">
                <Card.Title>{update.title}</Card.Title>
                <Card.Link
                  onClick={() => {
                    track(trackingEvents.productUpdates.visitProductUpdatesDetailPage, {
                      slug: update.slug,
                      origin: 'omnibutton-sidebar',
                    })
                    onClose()
                  }}
                  to={navigation.discover.productUpdates.item.fullPath({ slug: update.slug })}
                >
                  {i18n.t('product_updates.omnibutton.read_more')}
                </Card.Link>
              </Box>
            </Card.Content>
          </Card>
        </Box>
      ))}
    </Sidepanel>
  )
}
